module.exports = __webpack_public_path__ + "static/media/play-store-logo.b963728f.png";